/**
 * External dependencies
 */
import {registerPlugin} from '@wordpress/plugins';
import {getSetting} from '@woocommerce/settings';
import {ExperimentalOrderShippingPackages} from '@woocommerce/blocks-checkout';
/**
 * Internal dependencies
 */
import './style.scss';

const dataFromBlockSettings = getSetting('wcmultishipping_data');


const MyCustomComponent = ({
	cart,
	extensions
}) => {

	let selected_shipping_method, display_wms_block_value = undefined;

	if(undefined == cart?.shippingRates[0]) return;

	//Check all shipping methods and pick the selected one
	for(let one_shipping_method of cart?.shippingRates[0]?.shipping_rates){
		if(one_shipping_method.selected === true){
			selected_shipping_method = one_shipping_method.method_id;
		}
	}

	if(undefined == selected_shipping_method ||
	   (-1 == selected_shipping_method.indexOf("relais") && -1 == selected_shipping_method.indexOf("2shop") && -1 == selected_shipping_method.indexOf("access_point"))){
		display_wms_block_value = 'none';
	}else{
		display_wms_block_value = 'block';
		set_wms_popup_class();
	}


	return <div id="wms_pickup_woo_block" style={{display: display_wms_block_value}}>
		<button style={{
			padding: 4,
			border: 2,
			borderColor: 'black',
			borderStyle: 'solid',
			marginTop: 20,
			marginBottom: 20
		}}
				className="wms_pickup_selection_button"
				chronopost_modal_id={dataFromBlockSettings['chronopost_modal_id']}
				mondial_relay_modal_id={dataFromBlockSettings['mondial_relay_modal_id']}
				ups_modal_id={dataFromBlockSettings['ups_modal_id']}
		>
			{dataFromBlockSettings['choose-pickup-text']}
		</button>
		<div id="wms_ajax_error"></div>
		<div id="wms_selected_pickup_desc">
			<strong>{dataFromBlockSettings['package-shipping-text']}</strong>
			<div id="wms_pickup_selected">{dataFromBlockSettings['please-select-pickup-text']}</div>
		</div>
		<input type="hidden" id="wms_nonce" value={dataFromBlockSettings['nonce']}/>
		<input type="hidden" id="wms_shipping_provider"/>
		<input type="hidden" id="wms_pickup_point"/>
		<input type="hidden" id="wms_pickup_info"/>
	</div>;
};

const render = () => {
	return (
		<>
			<ExperimentalOrderShippingPackages>
				<MyCustomComponent/>
			</ExperimentalOrderShippingPackages>
		</>
	);
};


registerPlugin('wcmultishipping', {
	render,
	scope: 'woocommerce-checkout'
});


function set_wms_popup_class(selected_shipping_method){
	let wms_buttons = document.getElementsByClassName('wms_pickup_selection_button');
	if(wms_buttons.length === 0) return;

	for(let wms_button of wms_buttons){

		if(undefined == selected_shipping_method) return;


		let shipping_provider_modal_class = '';
		if(-1 != selected_shipping_method.indexOf("mondial_relay")){
			jQuery('#wms_shipping_provider').val('mondial_relay');
			shipping_provider_modal_class = wms_button.getAttribute('mondial_relay_modal_id');
		}else if(-1 != selected_shipping_method.indexOf("chronopost")){
			jQuery('#wms_shipping_provider').val('chronopost');
			shipping_provider_modal_class = wms_button.getAttribute('chronopost_modal_id');
		}else if(-1 != selected_shipping_method.indexOf("ups")){
			jQuery('#wms_shipping_provider').val('ups');
			shipping_provider_modal_class = wms_button.getAttribute('ups_modal_id');
		}


		jQuery(wms_button).removeAttr("wms-backbone-set");
		jQuery(wms_button).removeClass();
		jQuery(wms_button).addClass(shipping_provider_modal_class).addClass('wms_pickup_selection_button');
		wms_button.replaceWith(wms_button.cloneNode(true));

		if(-1 != shipping_provider_modal_class.indexOf("google")) set_wms_google_maps_pickup_modal('wms_pickup_selection_button',
																								   shipping_provider_modal_class);
		else if(-1 != shipping_provider_modal_class.indexOf("openstreetmap")) set_wms_openstreetmap_pickup_modal('wms_pickup_selection_button',
																												 shipping_provider_modal_class);
		else if(-1 != shipping_provider_modal_class.indexOf("mondial_relay")) set_wms_mondial_relay_pickup_modal('wms_pickup_selection_button',
																												 shipping_provider_modal_class);
	}
}

